import { FC } from 'react';
import { useTranslation } from '../../../utils/useTranslation';
import { WithHint } from '../../feedback/Tooltip';
import { IconInfo } from '../../icon/IconInfo';
import { IconYaPay } from '../../icon/IconYaPay';
import { IconYaSplit } from '../../icon/IconYaSplit';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { FintechDiscountBadgeProps } from './types';

export const FintechDiscountBadge: FC<FintechDiscountBadgeProps> = ({
    fintechDiscount,
    compact,
    hideTooltip,
}) => {
    const t = useTranslation();
    const discountData = fintechDiscount.yaPay || fintechDiscount.yaSplit;

    if (!discountData) {
        return null;
    }

    const { discountPercent, maxDiscountPercent, maxDiscountAmount } = discountData;
    const isYaPay = Boolean(fintechDiscount.yaPay);
    const serviceName = isYaPay ? t('Пэй') : t('Сплит');

    if (compact) {
        return (
            <Box display="inline-flex">
                <Typography
                    variant="caption2"
                    color="var(--search-red)"
                    border="1px solid var(--search-red)"
                    borderRadius={0.75}
                    px={0.5}
                >
                    {`${t('Вам')} –${discountPercent}%`}
                </Typography>
            </Box>
        );
    }

    return (
        <Box display="contents">
            <Typography
                variant="caption2"
                color="var(--search-red)"
                border="1px solid var(--search-red)"
                borderRadius={0.75}
                px={0.5}
            >
                {`${t('Вам')} –${discountPercent}%`}
            </Typography>
            <Flex direction="row" alignItems="center" spacing={0.25} flexWrap="nowrap">
                <Typography variant="caption">{isYaPay ? t('Картой') : t('в')}</Typography>
                {isYaPay ? (
                    <IconYaPay color="var(--color-primary)" size={14} />
                ) : (
                    <IconYaSplit color="var(--color-primary)" size={14} />
                )}
                <Typography variant="caption">{serviceName}</Typography>
                {maxDiscountPercent && maxDiscountAmount && !hideTooltip ? (
                    <WithHint
                        message={t(
                            `При переходе по этой ссылке вы получите скидку до ${maxDiscountPercent}% на сайте продавца при оплате ${
                                isYaPay ? 'c Яндекс Пэй' : 'в СПЛИТ'
                            }. Максимальная скидка — ${maxDiscountAmount} руб`,
                        )}
                        trigger={
                            <IconInfo color="var(--color-secondary)" cursor="pointer" size={14} />
                        }
                    />
                ) : null}
            </Flex>
        </Box>
    );
};
